import { render, staticRenderFns } from "./Lgx02829476086907863564409.vue?vue&type=template&id=67ef3806&"
import script from "./Lgx02829476086907863564409.vue?vue&type=script&lang=js&"
export * from "./Lgx02829476086907863564409.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports